import React from "react";

/**
 * Chapter — numbered manifesto marker that opens each section of the
 * landing ("01 — Comunidad", "02 — Comunidad viva"...). Deliberately
 * plain: the surrounding Reveal already handles the scroll animation.
 *
 * Tones:
 *  - jade:  on light backgrounds (default)
 *  - light: on jade / dark backgrounds
 *  - ink:   muted dark grey
 */

const TONES = {
  jade: "text-[#63846F]",
  light: "text-[#FAF8F3]/75",
  ink: "text-[#3F403A]/70",
};

const Chapter = ({ number, label, tone = "jade", className = "" }) => (
  <div
    className={`flex items-center gap-4 md:gap-5 mb-6 ${TONES[tone] || TONES.jade} ${className}`}
    data-testid={`chapter-${number}`}
  >
    <span className="font-serif italic text-3xl md:text-4xl leading-none">
      {number}
    </span>
    <span className="h-px w-10 md:w-14 bg-current opacity-50" aria-hidden />
    <span className="overline">{label}</span>
  </div>
);

export default Chapter;
